
import { defineComponent } from "vue";
import Slide1 from "./app-slide/slide1.vue";
import Slide2 from "./app-slide/slide2.vue";
import Slide3 from "./app-slide/slide3.vue";
import Slide4 from "./app-slide/slide4.vue";
import AppFooter from "./app-footer/index.vue";
import { getService } from "@/service";

export default defineComponent({
  created() {
    this.initUrls();
  },
  data() {
    return { btyUrl: "" };
  },
  components: {
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    AppFooter,
  },
  methods: {
    async initUrls() {
      const res = await getService().global.downloadUrl();
      if (!res) {
        return;
      }
      const { pc, h5 } = res;
      if (pc) {
        this.btyUrl = pc;
      } else {
        this.btyUrl = (h5 || "").replace(/(https?:\/\/)m\./, "$1www.");
      }
    },
  },
  render() {
    return (
      <div class="home">
        <Slide1 btyUrl={this.btyUrl} />
        <Slide2 btyUrl={this.btyUrl} />
        <Slide3 btyUrl={this.btyUrl} />
        <Slide4 btyUrl={this.btyUrl} />
        <AppFooter />
      </div>
    );
  },
});
